import type { Layout } from '../../data/types';
import type { SiteModel } from '../../site/types';
import type { PlannedLots } from '../fabric/fabricLots';
import { pointInRing } from '../../geo/polygon';
import { waterAccesses, waterAccessFootprint } from '../../site/waterAccess';
import { placeQuayGoods, QUAY_GOODS } from '../streetscape/quayGoods';
import { groundOf, type Ground } from './crowd/walkNet';

/** Walkers can use quay steps, but a loaded cart also needs clear ground for both wheels. */
export function cargoGround(layout: Layout, site: SiteModel, lots: PlannedLots): Ground {
  const ground = groundOf(layout, site, lots);
  const obstacles = [
    ...waterAccesses(layout).map(waterAccessFootprint),
    ...placeQuayGoods(QUAY_GOODS, layout.streets, (p) => site.queries.isWater(p)).map(
      (item) => item.footprint
    ),
  ];
  return {
    ...ground,
    open: (p) => ground.open(p) && !obstacles.some((ring) => pointInRing(p, ring)),
  };
}
